/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A time-boxed period in which marker-carrying co-streams count as on-game. Expires by construction.
 * @export
 * @interface DropCampaignWindow
 */
export interface DropCampaignWindow {
    /**
     * 
     * @type {string}
     * @memberof DropCampaignWindow
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof DropCampaignWindow
     */
    startsAt: number;
    /**
     * Required. A window with no end is not a window.
     * @type {number}
     * @memberof DropCampaignWindow
     */
    endsAt: number;
    /**
     * Tag or title token the creator must carry, e.g. "#MW4Reveal".
     * @type {string}
     * @memberof DropCampaignWindow
     */
    marker: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DropCampaignWindow
     */
    extraCategories: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DropCampaignWindow
     */
    label?: string;
}

/**
 * Check if a given object implements the DropCampaignWindow interface.
 */
export function instanceOfDropCampaignWindow(value: object): value is DropCampaignWindow {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('startsAt' in value) || value['startsAt'] === undefined) return false;
    if (!('endsAt' in value) || value['endsAt'] === undefined) return false;
    if (!('marker' in value) || value['marker'] === undefined) return false;
    if (!('extraCategories' in value) || value['extraCategories'] === undefined) return false;
    return true;
}

export function DropCampaignWindowFromJSON(json: any): DropCampaignWindow {
    return DropCampaignWindowFromJSONTyped(json, false);
}

export function DropCampaignWindowFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropCampaignWindow {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'startsAt': json['startsAt'],
        'endsAt': json['endsAt'],
        'marker': json['marker'],
        'extraCategories': json['extraCategories'],
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function DropCampaignWindowToJSON(json: any): DropCampaignWindow {
    return DropCampaignWindowToJSONTyped(json, false);
}

export function DropCampaignWindowToJSONTyped(value?: DropCampaignWindow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'startsAt': value['startsAt'],
        'endsAt': value['endsAt'],
        'marker': value['marker'],
        'extraCategories': value['extraCategories'],
        'label': value['label'],
    };
}

